export const getPagination = ({ pagination }) => pagination;
export const mesadiretora_default = () => ({
  conselho_id: null,
  mandato_id: null,
  mesa_diretora_cargos: [],
});

export const cargos_default = () => [
  {
    conselheiro_id: null,
    cargo: "presidente",
    cargo_outro: "Presidente",
    grupo: null
  },
  {
    conselheiro_id: null,
    cargo: "vice-presidente",
    cargo_outro: "Vice Presidente",
    grupo: null
  },
  {
    conselheiro_id: null,
    cargo: "1º secretario",
    cargo_outro: "1º Secretário",
    grupo: null
  },
  {
    conselheiro_id: null,
    cargo: "2º secretario",
    cargo_outro: "2º Secretário",
    grupo: null
  },
  {
    conselheiro_id: null,
    cargo: "1º tesoureiro",
    cargo_outro: "1º Tesoureiro",
    grupo: null
  },
  {
    conselheiro_id: null,
    cargo: "2º tesoureiro",
    cargo_outro: "2º Tesoureiro",
    grupo: null
  },
];

export const cargos_fixos = () => [
  "presidente",
  "vice-presidente",
  "1º secretario",
  "2º secretario",
  "1º tesoureiro",
  "2º tesoureiro",
];
